<template>
    <div class="sector-popup" v-if="flattenedSectors && flattenedSectors.length">
        <span v-text="label" class="sector-popup__label"/>
        <div class="sector-popup__dropdown">
            <div class="sector-popup__items">
                <span class="sector" v-for="sector in flattenedSectors" v-text="sector.label"/>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'SectorPopup',
    props: {
        sectors: {
            type: Array,
            default: [],
        },
    },
    methods: {
         flatten: function(arr) {
            return arr.reduce((acc, item) => {
                acc.push(item);
                if (item.children && Array.isArray(item.children)) {
                    acc.push(...this.flatten(item.children));
                }
                return acc;
            }, []);
        }
    },
    computed: {
        label() {
            if(this.flattenedSectors.length < 1) {
                return 'Uncategorized';
            }

            if(this.flattenedSectors.length === 1) {
                return 'Tagged to 1 Sector';
            }

            return `Tagged to ${ this.flattenedSectors.length } Sectors`;
        },
        flattenedSectors: function() {
            return this.flatten(this.sectors);
        }
    },
}
</script>
<style scoped lang="scss">
@import '~@/theme/_variables.scss';
.sector-popup {
    position: relative;

    .sector-popup__label {
        display: inline-flex;
        border: 0.1rem solid $text;
        color: $text;
        border-radius: 0.2rem;
        padding: 0.2rem 0.6rem;
    }

    .sector-popup__dropdown {
        right: 0;
        top: calc(100% - 2px);
        position: absolute;
        display: none;
        padding-top: 1rem;

        .sector-popup__items {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            background-color: white;
            box-shadow: 0 6px 20px 0 rgba(49, 49, 74, 0.16);
            max-width: 36rem;
            padding: 1rem;
            gap: .4rem;
            z-index: 10;

            .sector {
                margin-bottom: 0;
                margin-right: 0;
            }
        }
    }

    &:hover {
        .sector-popup__dropdown {
            display: block;
        }
    }
}
</style>
